module.exports = __webpack_public_path__ + "img/SC-6999.05d6647f.png";